<div>
	<div *ngIf="step === 1">
		<div class="register-photo">
			<div class="form-container">
				<div class="form" style="align-self: center!important; width: 100% !important;">
					<div class="p-grid form-group">
						<div class="p-col-12 warning--message" *ngIf="detalle">
							<p><b>{{ titulo }}</b></p>
							<p class="mt--8">{{ detalle }}</p>
						</div>
						<div class="image-holder">
							<img src="assets/img/DNM/logo_20.png" class="top-img">
						</div>
						<div class="form">
							<h2>Registrarse</h2>
							<p>Si aún no tienes una cuenta puedes registrarte completando el siguiente formulario</p>
							<div class="p-col-12">
								<p>¿Que tipo de usuario eres?</p>
								<p-dropdown [options]="newUserOptions" class="custom-input-select" [(ngModel)]="newUser" placeholder="Selecciona una opción..."></p-dropdown>
								<p *ngIf="newUser === 0" style="color: #31394569; text-align: justify;"><i class="pi pi-exclamation-circle"></i> Si ya posees un usuario de portalenlinea.srs.gob.sv puedes migrarlo, haz clic en siguiente para continuar.</p>
								<p *ngIf="newUser === 1" style="color: #31394569; text-align: justify;"><i class="pi pi-exclamation-circle"></i> Haz clic en siguiente para completar el formulario de registro.</p>
								<p *ngIf="newUser === 2"></p>
							</div>
							<div class="p-col-12" style="position: relative; display: flex; justify-content: center;">
								<button *ngIf="newUser === 0" 
									[label]="Siguiente" 
									pButton [routerLink]="'/auth/migration-user'" 
									icon="fa fa-arrow-right" 
									class="custom-input-button" style="position: absolute;">
								</button>
								<button *ngIf="newUser === 1" 
									[label]="Siguiente" 
									pButton (click)="nextStep(2)" 
									icon="fa fa-arrow-right" 
									class="custom-input-button" style="position: absolute;">
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="step === 2 && newUser === 1">
		<form [formGroup]="registrar" (ngSubmit)="crear()">
			<app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
			<div class="register-photo" style="background-color:rgb(255,255,255);">
				<div class="form-container">
					<div class="form" style="align-self: center!important; width: 100% !important;">
						<div class="p-grid form-group">
							<div class="p-col-3 p-md-3 p-lg-3" style="border-right: 1px solid #F2F2F2;">
								<img src="assets/img/DNM/logo_20.png" class="top-img" style="width: 7vw;">
							</div>
							<div class="p-col-9 p-md-9 p-lg-9">
								<h2 style="margin-left: 15%; margin-top: 5%;">Completar Registro</h2>
							</div>
						</div>
						<div class="p-grid form-group">
							<div class="p-grid p-col-12">
								<div class="p-col-6">
									<div  class="p-col-12">
										<h4>Selecciona el tipo de persona a registrar para crear su cuenta</h4>
										<p-listbox [options]="personas" (onChange)="per($event)" formControlName="tipo_persona" id="tipo_persona">
										</p-listbox>
										<span *ngIf="registrar.get('tipo_persona').hasError('required')">
											<p-message severity="error" text="El tipo de persona es requerido."></p-message>
										</span>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Tipo de documento</h4>
										<p-listbox [options]="documentos" (onChange)="doc($event)" formControlName="doc" id="doc">
										</p-listbox>
										<span *ngIf="registrar.get('doc').hasError('required')">
											<p-message severity="error" text="El tipo de documento es requerido."></p-message>
										</span>
									</div>
								</div>
							</div>
							<div class="p-grid p-col-12" *ngIf="DocDUI == true" >
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>DUI</h4>
										<div class="ui-inputgroup">
											<p-inputMask formControlName="dui" id="dui" mask="99999999-9" unmask="true" placeholder="00000000-0"></p-inputMask>
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('dui').hasError('pattern')">
												<p-message severity="error" text="El carnet de residente contiene un carácter no permitido.">
												</p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Acción</h4>
										<!--<p-fileUpload #fileUpload id="dui_archivo" mode="basic" [customUpload]="true" name="demo[]"
										(onSelect)="archivo($event, 1)" chooseLabel="Carga archivo" chooseIcon="pi pi-upload" 
										(uploadHandler)="fileUpload.clear()" (onClear)="clearFile(1)"
										></p-fileUpload>-->
										<div style="display:flex; justify-content:flex-start; align-items:center; gap:8px;">
											<button type="button" pButton label="Buscar" icon="fa fa-search" class="custom-input-button" (click)="buscar()" title="Buscar"></button>
											<button type="button" pButton label="Limpiar" icon="fa fa-times" class="custom-input-button" (click)="limpiar()" title="Limpiar"></button>
										</div>
									</div>
								</div>
							</div>
							<div class="p-grid p-col-12" *ngIf="DocCarnet == true">
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Carnet de Residente</h4>
										<div class="ui-inputgroup">
											<input type="text" pInputText formControlName="carnet_residente" id="carnet_residente" placeholder="0000000">
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('carnet_residente').hasError('pattern')">
												<p-message severity="error" text="El carnet de residente contiene un carácter no permitido.">
												</p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Documento</h4>
										<p-fileUpload #fileUpload id="carnet_residente_archivo" mode="basic" [customUpload]="true" name="demo[]"
										(onSelect)="archivo($event, 2)" chooseLabel="Carga archivo" chooseIcon="pi pi-upload" 
										(uploadHandler)="fileUpload.clear()" (onClear)="clearFile(2)"
										></p-fileUpload>
									</div>
								</div>
							</div>
							<div class="p-grid p-col-12" *ngIf="DocPasaporte == true">
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Pasaporte</h4>
										<div class="ui-inputgroup">
											<input type="text" pInputText formControlName="pasaporte" id="pasaporte" placeholder="P000000000">
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('pasaporte').hasError('pattern')">
												<p-message severity="error" text="El pasaporte contiene un carácter no permitido."></p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Documento</h4>
										<p-fileUpload #fileUpload id="pasaporte_archivo" mode="basic" [customUpload]="true" name="demo[]"
										(onSelect)="archivo($event, 3)" chooseLabel="Carga archivo" chooseIcon="pi pi-upload" 
										(uploadHandler)="fileUpload.clear()" (onClear)="clearFile(3)"
										></p-fileUpload>
									</div>
								</div>
							</div>
 						</div>
						<hr style="border: 0; border-top: 1px #31394547 solid;">
						<div class="p-grid form-group">
							<div class="p-grid p-col-12">
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Nombres</h4>
										<div class="ui-inputgroup">
											<span *ngIf="DocDUI == true">
											<input type="text" disabled="true" pInputText formControlName="nombre" id="nombre">
											</span>
											<span *ngIf="DocDUI == false">
											<input type="text" pInputText formControlName="nombre" id="nombre">
											</span>
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('nombre').hasError('pattern')">
												<p-message severity="error" text="El nombre contiene un carácter no permitido."></p-message>
											</span>
											<span *ngIf="registrar.get('nombre').hasError('minLength')">
												<p-message severity="error" text="El nombre debe contener más de 3 caracteres."></p-message>
											</span>
											<span *ngIf="registrar.get('nombre').hasError('maxLength')">
												<p-message severity="error" text="El nombre debe contener menos de 100 caracteres."></p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Apellidos</h4>
										<div class="ui-inputgroup">
											<span *ngIf="DocDUI == true">
											<input type="text" disabled="true" pInputText formControlName="apellido" id="apellido">
											</span>
											<span *ngIf="DocDUI == false">
											<input type="text" pInputText formControlName="apellido" id="apellido">
											</span>
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('apellido').hasError('pattern')">
												<p-message severity="error" text="El apellido contiene un carácter no permitido."></p-message>
											</span>
											<span *ngIf="registrar.get('apellido').hasError('minLength')">
												<p-message severity="error" text="El apellido debe contener más de 3 caracteres."></p-message>
											</span>
											<span *ngIf="registrar.get('apellido').hasError('maxLength')">
												<p-message severity="error" text="El apellido debe contener menos de 100 caracteres."></p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Correo electrónico</h4>
										<div class="ui-inputgroup">
											<input type="email" pInputText formControlName="correo" id="correo">
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('correo').hasError('email')">
												<p-message severity="error" text="El correo contiene un carácter no permitido."></p-message>
											</span>
											<span *ngIf="registrar.get('correo').hasError('maxLength')">
												<p-message severity="error" text="El correo debe contener menos de 100 caracteres."></p-message>
											</span>
											<span *ngIf="registrar.get('correo').hasError('required')">
												<p-message severity="error" text="El correo es requerido."></p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Teléfono</h4>
										<div class="ui-inputgroup">
											<p-inputMask formControlName="telefono" id="telefono" mask="9999-9999"></p-inputMask>
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('telefono').hasError('pattern')">
												<p-message severity="error" text="El teléfono que intenta digitar no es válido."></p-message>
											</span>
											<span *ngIf="registrar.get('telefono').hasError('minLength')">
												<p-message severity="error" text="El teléfono debe contener más de 6 caracteres."></p-message>
											</span>
											<span *ngIf="registrar.get('telefono').hasError('maxLength')">
												<p-message severity="error" text="El teléfono debe contener menos de 20 caracteres."></p-message>
											</span>
											<span *ngIf="registrar.get('telefono').hasError('required')">
												<p-message severity="error" text="El teléfono es requerido."></p-message>
											</span>
										</div>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Teléfono secundario</h4>
										<div class="ui-inputgroup">
											<p-inputMask formControlName="telefono_secundario" id="telefono_secundario" mask="9999-9999"></p-inputMask>
										</div>
										<div class="ui-inputgroup">
											<span *ngIf="registrar.get('telefono_secundario').hasError('pattern')">
												<p-message severity="error" text="El teléfono secundario que intenta digitar no es válido.">
												</p-message>
											</span>
											<span *ngIf="registrar.get('telefono_secundario').hasError('minLength')">
												<p-message severity="error" text="El teléfono secundario debe contener más de 6 caracteres.">
												</p-message>
											</span>
											<span *ngIf="registrar.get('telefono_secundario').hasError('maxLength')">
												<p-message severity="error" text="El teléfono secundario debe contener menos de 20 caracteres.">
												</p-message>
											</span>
										</div>
									</div>
								</div>
							</div>
							<div class="p-grid p-col-12">
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Género</h4>
										<p-dropdown [options]="generos" formControlName="genero" id="genero" placeholder="Selecciona una opción" class="custom-input-select full-width-dropdown"></p-dropdown>
										<span *ngIf="registrar.get('genero').hasError('required')">
											<p-message severity="error" text="El genero es requerido."></p-message>
										</span>
									</div>
								</div>
								<div class="p-col-6">
									<div class="p-col-12">
										<h4>Tratamiento</h4>
										<p-dropdown [options]="tratamientos" formControlName="tratamiento" id="tratamiento" placeholder="Selecciona una opción" class="custom-input-select full-width-dropdown"></p-dropdown>
										<span *ngIf="registrar.get('tratamiento').hasError('required')">
											<p-message severity="error" text="El tratamiento es requerido."></p-message>
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="p-col-12">
							<p>Para completar el registro debes confirmar que aceptas los términos y condiciones de uso de la ventanilla electrónica SRS, haz clic en siguiente para continuar.</p>
							<div class="p-col-12" style="position: relative; display: flex; justify-content: center;">
								<button [disabled]="!registrar.valid"  
									(click)="showModal($event)"
									pButton 
									label="Siguiente" 
									icon="fa fa-arrow-right" 
									class="custom-input-button" style="position: absolute;">
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<app-spinner [visible]="visibleSpinner"></app-spinner>
		</form>
	</div>
</div>
<p-dialog header="Términos y condiciones de uso de la ventanilla electrónica SRS " [(visible)]="displayModalConditions" [modal]="true">
	<div class="terms_conditions" style="padding: 0px 20px">
		<p>Leer detenidamente el presente contrato que contiene los términos y condiciones que regirán la utilización de la ventanilla electrónica SRS a través de la cual se tramitarán las solicitudes relativas a los servicios competencia de la Superintendencia de Regulación Sanitaria. </p>
		<ol>
			<li>Los derechos de titularidad y propiedad intelectual de la ventanilla electrónica SRS pertenecen a la Superintendencia de Regulación Sanitaria. Se prohíbe toda reproducción o representación por cualquier medio o motivo, de la referida ventanilla.</li>
			<li>Podrán realizar trámites, las personas naturales previamente registradas según el acceso otorgado, por medio de un usuario y contraseña. </li>
			<li>El acceso otorgado será de uso exclusivo de la persona solicitante y esta será responsable de su uso, por tanto, cualquier gestión que se realice a través del mismo, se entenderá realizada por su titular.</li>
			<li>La ventanilla electrónica SRS estará habilitada las veinticuatro horas para consulta e ingreso de trámites, no obstante, la recepción de los trámites fuera del horario de las 8:00 a las 16:00 horas de días hábiles, se entenderá recepcionado en el horario hábil siguiente.</li>
			<li>La SRS dará mantenimiento a la plataforma la ventanilla electrónica.</li>
			<li>La Superintendencia de Regulación Sanitaria verificará la identidad a través del usuario y contraseña.</li>
			<li>Las gestiones realizadas a través del usuario y contraseña ingresados en la ventanilla, tendrán la calidad de firma electrónica simple y, por tanto, la misma validez jurídica que la firma autógrafa, de conformidad a lo establecido en el artículo 6 de la Ley de firma electrónica.</li>
			<li>El usuario se compromete a usar adecuadamente el contenido y servicios ofrecidos en la ventanilla electrónica SRS, por tanto, el usuario se limitará al uso de la plataforma en el sentido de: </li>
			<ul>
				<li>No utilizar el contenido para incurrir y/o incitar a terceros a realizar actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.</li>
				<li>No usar secuencias de comandos automatizadas para recopilar información publicada en la plataforma o a través de la misma o para interactuar de cualquier otro modo con estos.</li>
				<li>Intentar acceder, recolectar o almacenar los datos personales de otros administrados usuarios del portal y, en su caso, utilizar las cuentas de correo electrónico de otros administrados usuarios y modificar o manipular sus mensajes.</li>
			</ul>
			<li>La SRS no será responsable de:</li>
			<ul>
				<li>Los pagos erróneos efectuados en la gestión de sus trámites.</li>
				<li>Errores o mal funcionamiento de los ordenadores o dispositivos electrónicos. </li>
				<li>Información ingresada o requerida por terceros en ventanas emergentes no relacionadas  a la Ventanilla Electrónica SRS.</li>
				<li>Cambios aplicados al diseño, función, estructura o especificaciones de servicios prestados por terceros en la Ventanilla Electrónica SRS </li>
				<li>Inhabilitación de ventanas emergentes.</li>
				<li>Fallas en el suministro del servicio de internet contratado.</li>
				<li>Documentos cargados a la ventanilla electrónica SRS.</li>
				<li>Ingresar a vínculos remitidos por correos electrónicos o publicaciones que no sean emitidas por la SRS a través de sus cuentas oficiales.</li>
			</ul>
			<li>El usuario acepta como medio de notificación la ventanilla electrónica. Por lo cual toda notificación realizada deberá ser verificada en la Ventanilla Electrónica SRS, de conformidad a los artículos 97 y siguientes de la Ley de Procedimientos Administrativos.</li>
			<li>La SRS podrá desactivar, suspender o cancelar accesos a usuarios.</li>
		</ol>
		<p><b>El usuario declara la autenticidad y veracidad de la información consignada e ingresada en la ventanilla electrónica SRS, y que, en caso de no ser cierta dicha información, asume las consecuencias legales que de ello resulten. Asimismo, al crear la cuenta confirma que los datos y documentos proporcionados hacen referencia al titular de la cuenta.</b></p>
		<br><br>
		<div class="p-col-12" style="position: relative; display: flex; justify-content: center;">
			<div class="checkbox" style="position: absolute; left: 0; width: 25vw; align-content: baseline; align-items: baseline;">
				<p-checkbox name="groupname" (onChange)="changeConditions()" label="Acepto los términos y condiciones"></p-checkbox>
			</div>
			<button [disabled]="!checkConditions"
				(click)="crear()"
				pButton 
				label="Finalizar Registro" 
				icon="fa fa-arrow-right" 
				class="custom-input-button" style="position: absolute; right: 0; max-width: 15vw;">
			</button>
		</div>
		<br><br>
	</div>	
</p-dialog>
